<template>
  <Flex class="wrapper" align="center">
    <Flex :gap="5" direction="column" align="center">
      <Flex justify="center">
        <Logo :width="112" :height="112" />
      </Flex>
      <p class="md-typescale-body-large description">
        {{ t('sign_in.description', { phoneNumber: usersPhoneNumber }) }}
      </p>
      <SendOtpForm
        :usersPhone="usersPhoneNumber"
        @success="successHandler"
        @expired="otpSent = false" />
      <Flex>
        <OTPInputForm :usersPhone="usersPhoneNumber" :otpSent="otpSent" />
      </Flex>
    </Flex>
  </Flex>
</template>

<script lang="ts" setup>
import OTPInputForm from '@/features/SmsCodeVerification/components/OTPInputForm/OTPInputForm.vue';
import SendOtpForm from '@/features/SmsCodeVerification/components/SendOtpForm/SendOtpForm.vue';
import Flex from '@/components/Flex/Flex.vue';
import { useI18n } from 'vue-i18n';
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Logo from '@/components/Logo/Logo.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const otpSent = ref(false);

const addPlusPrefixAndRemoveSpace = (value: string) => {
  const valueWithoutSpace = value.replaceAll(' ', '');

  return valueWithoutSpace[0] === '+'
    ? valueWithoutSpace
    : `+${valueWithoutSpace}`;
};

onMounted(async () => {
  const usersPhone = route.query.phoneNumber as string;

  if (!usersPhone) {
    await router.push('/sign-in');

    return;
  }
});

const usersPhoneNumber = computed(() => {
  const { phoneNumber } = route.query;
  let finalPhoneNumber = phoneNumber || '';

  if (Array.isArray(finalPhoneNumber)) {
    finalPhoneNumber = finalPhoneNumber[0] as string;
  }

  return addPlusPrefixAndRemoveSpace(finalPhoneNumber);
});

const successHandler = () => {
  otpSent.value = true;
};
</script>
<style scoped>
.description {
  color: var(--md-sys-dark-surface-variant);
  text-align: justify;
}

.wrapper {
  height: 100%;
}
</style>
